import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { stroke: true },
  },
});

type AccountInactiveIconProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function AccountInactiveIcon({
  className,
  pathClassName = "stroke-white",
  ...props
}: AccountInactiveIconProps) {
  return (
    <Svg
      width={28}
      height={29}
      viewBox="0 0 28 29"
      fill="none"
      className={className}
      {...props}
    >
      <Path
        d="M5.25 14.5h17.5M5.25 21.23h17.5M5.25 7.77h17.5"
        className={pathClassName}
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
    </Svg>
  );
}

export default AccountInactiveIcon;
